<div class="p-dialog-header pl-0 pr-0 flex justify-content-between">
    <span class="p-dialog-title" i18n="@@workspace-picker.dialog.header">Please choose a file</span>
    <button type="button" pButton icon="far fa-times" class="p-button-text" (click)="dialogRef.close(null)"></button>
</div>

<div class="flex-1 relative">
    <div class="absolute w-full h-full">
        <p-tree [value]="workspaceFiles" scrollHeight="flex" selectionMode="single" [filter]="false" [(selection)]="selectedFile"
        emptyMessage="No files found" i18n-emptyMessage="@@workspace-explorer.empty">
        <ng-template let-node pTemplate="ROOT">
            <div class="flex align-items-center justify-content-between flex-row ">
                <div class="flex-1">&nbsp;</div>
            </div>
        </ng-template>
        <ng-template let-node pTemplate="default">
            <div id="{{node.data.id}}" (dblclick)="chooseDoubleClick()">{{node.label}}</div>
        </ng-template>

        <ng-template pTemplate="header">
            <div class="flex mb-3 flex-row">
                <div class="flex-1">

                    <p-iconfield>
                        <p-inputicon styleClass="far fa-magnifying-glass" />
                        <input type="text" pInputText (keyup)="refresh()" class="w-full" [(ngModel)]="activeFilterSearchWord" />
                    </p-iconfield>              
                </div>
                <div class="w-2rem ml-2 text-right">
                    <button pButton type="button" icon="far fa-arrow-up-arrow-down"
                    class="p-button-rounded p-button-text" (click)="openSortMenuForItem($event,workspaceFiles[0])"></button>
                   </div>
            </div>
        </ng-template>
    </p-tree>
    </div>
</div>
<div class="p-dialog-footer p-0 text-right mt-2">
    <ng-container *ngIf="selectedFile">
        <button pButton label="Choose File" i18n-label="@@workspace-picker.dialog.button-choose"  *ngIf="isValidSelection()" (click)="closeDialog(selectedFile)"></button>
        <div *ngIf="!isValidSelection()">
            <p-message severity="warning" i18n-text="@@workspace-picker.dialog.invalid-file" text="Invalid selection. The selected file cannot be used in this context." ></p-message>
        </div>
    </ng-container>

</div>
<p-menu #sm [popup]="true" [model]="sortMenuOptions" appendTo="body"></p-menu>